import { Box, Button, Tab, Tabs } from '@mui/material';
import { FunctionComponent, SyntheticEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { TabPanel } from '../../../components/TabPanel/TabPanel';
import { useCurrentEventQuery } from '../../../event/hooks/useCurrentEventQuery';
import { Layout } from '../../../navigation/components/Layout/Layout';
import { useCurrentUserQuery } from '../../../user/hooks/useCurrentUserQuery';
import { TinderLikedUsersTab } from './components/TinderLikedUsersTab/TinderLikedUsersTab';
import { TinderSuperLikedUsersTab } from './components/TinderSuperLikedUsersTab/TinderSuperLikedUsersTab';
import { UserMatchesTab } from './components/UserMatchesTab/UserMatchesTab';

function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

export const TinderedUsers: FunctionComponent = () => {
  const { data: currentUserData } = useCurrentUserQuery();
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);
  const { data: currentEventData } = useCurrentEventQuery();
  const navigate = useNavigate();

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setCurrentTabIndex(newValue);
  };

  if (!currentEventData?.currentEvent) {
    return null;
  }

  const isAdmin = currentUserData?.currentUser?.isAdmin ?? false;

  return (
    <Layout title="Meetic leaderboard" activeTab="tinder">
      <Button variant="outlined" onClick={() => navigate('/tinder')}>
        Retour au swipe
      </Button>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={currentTabIndex}
          onChange={handleChange}
          aria-label="Meetic tabs"
        >
          <Tab label="Matches" {...a11yProps(0)} />
          {isAdmin ? <Tab label="Plus liké" {...a11yProps(1)} /> : null}
          {isAdmin ? <Tab label="Plus super liké" {...a11yProps(2)} /> : null}
        </Tabs>
      </Box>
      <TabPanel value={currentTabIndex} index={0}>
        <UserMatchesTab eventId={currentEventData.currentEvent.id} />
      </TabPanel>
      {isAdmin ? (
        <TabPanel value={currentTabIndex} index={1}>
          <TinderLikedUsersTab eventId={currentEventData.currentEvent.id} />
        </TabPanel>
      ) : null}
      {isAdmin ? (
        <TabPanel value={currentTabIndex} index={2}>
          <TinderSuperLikedUsersTab
            eventId={currentEventData.currentEvent.id}
          />
        </TabPanel>
      ) : null}
    </Layout>
  );
};
